import { useState } from 'react';
import { copyText } from '../lib/copy';

export function CopyButton({ text, label }: { text: string; label?: string }) {
  const [state, setState] = useState<'idle' | 'ok' | 'fail'>('idle');
  const onClick = () => {
    void copyText(text).then((ok) => {
      setState(ok ? 'ok' : 'fail');
      setTimeout(() => { setState('idle'); }, 1500);
    });
  };
  return (
    <button type="button" className={state === 'ok' ? 'copy did' : 'copy'} data-copy={text} aria-label={`Copy ${label ?? text}`} onClick={onClick}>
      {state === 'idle' ? 'copy' : state === 'ok' ? 'copied' : 'copy failed'}
    </button>
  );
}
